import PropTypes from 'prop-types';
// material
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

LogoRound.propTypes = {
  sx: PropTypes.object
};

export default function LogoRound({ sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  return <Box component="img" src="/static/brand/volt_logo_single.png" sx={{ width: 200, height: 200, ...sx }} />;
}
